import chroma from 'chroma-js'
import { getHexCodesFromCBVTheme } from './utils/cbvThemes'

export interface IGradientIcon {
  /**
   * default: `w-5 rounded`
   */
  className?: string
  hexCodes?: string[]
  range?: number
}

/**
 * Generate Gradient Icon from provided parameters
 *
 * If colors provided is more than range specifed, we will only
 * select color up to range in provided order.
 *
 * TODO: If colors provided is less than range specified, we
 * will interpolate the intermediate colors. In this case, any
 * color between the first and last is not guaranteed to be
 * picked and instead an interprolated color may be used.
 *
 * @param { className } string prop drill class name, for size adjustment
 * @param { hexCodes } string[] array of hex color codes, from light to dark
 * @param { range } number of distinct colors to show in the icon
 * @returns Icon with color gradient rendered in top down order
 */
const GradientIcon = ({
  className = 'h-5 w-5 rounded',
  hexCodes = getHexCodesFromCBVTheme('lighthouse'),
  range = 4
}: IGradientIcon) => {
  let colors = hexCodes.slice(range)

  if (colors.length < range) {
    colors = chroma.scale(hexCodes).colors(range)
  }

  return (
    <div className={`flex flex-col overflow-hidden ${className}`}>
      {colors.map((color, idx) => (
        <div key={idx} className='flex-1' style={{ backgroundColor: color }} />
      ))}
    </div>
  )
}

export default GradientIcon
